const EMPTY_DISCLAIMER = {
  text: '',
  tracking_page: false,
  thank_you_page: false,
  track_order_form: false,
}

/**
 * Menus are already in the startup async payload. Pinia holds the same
 * objects, so the HTML would contain them twice. The client copies startup
 * back into the store before hydration.
 */
export default defineNuxtPlugin({
  name: 'slim-pinia-payload',
  enforce: 'post',
  setup(nuxtApp) {
    if (!import.meta.server) {
      return
    }

    nuxtApp.hook('app:rendered', () => {
      const startup = nuxtApp.payload?.pinia?.startup
      if (!startup) {
        return
      }

      startup.header_right = []
      startup.header_left = []
      startup.side_menu = []
      startup.top_menu = []
      startup.side_menu_collections = []
      startup.main_menu_footer = []
      startup.countries = []
      startup.campaign = null
      startup.reviews = []
      startup.trustpilot_rating = null
      startup.disclaimer = { ...EMPTY_DISCLAIMER }
    })
  },
})
